import { useEffect } from 'react';

export default function useBlockMapScroll(target) {
    useEffect(() => {
        let el = null;
        let rafId = null;

        const resolveEl = () => {
            if (typeof target === 'string')
                return document.querySelector(target);
            if (target && typeof target === 'object' && 'current' in target)
                return target.current;
            return target || null;
        };

        const blockWheel = e => {
            if (!el) return;
            const isInside = el.contains(e.target);
            const isScrollable =
                el.scrollHeight > el.clientHeight ||
                el.scrollWidth > el.clientWidth;
            if (isInside && isScrollable) {
                e.stopPropagation();
            }
        };

        const blockDblClick = e => {
            if (!el) return;
            if (el.contains(e.target)) {
                e.stopPropagation();
                e.preventDefault();
            }
        };

        const blockMouseDown = e => {
            if (!el) return;
            if (el.contains(e.target)) {
                e.stopPropagation();
            }
        };

        const blockTouch = e => {
            if (!el) return;
            if (el.contains(e.target)) {
                e.stopPropagation();
            }
        };

        const attach = () => {
            el = resolveEl();
            if (!el || typeof el.addEventListener !== 'function') {
                rafId = requestAnimationFrame(attach);
                return;
            }
            el.addEventListener('wheel', blockWheel, { passive: true });
            el.addEventListener('dblclick', blockDblClick, { passive: false });
            el.addEventListener('mousedown', blockMouseDown, { passive: true });
            el.addEventListener('touchstart', blockTouch, { passive: true });
            el.addEventListener('touchmove', blockTouch, { passive: true });
        };

        attach();

        return () => {
            if (rafId) cancelAnimationFrame(rafId);
            if (el && typeof el.removeEventListener === 'function') {
                el.removeEventListener('wheel', blockWheel);
                el.removeEventListener('dblclick', blockDblClick);
                el.removeEventListener('mousedown', blockMouseDown);
                el.removeEventListener('touchstart', blockTouch);
                el.removeEventListener('touchmove', blockTouch);
            }
        };
    }, [target]);
}